/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelExperimentRunResponse
 */
export interface CancelExperimentRunResponse {
  /**
   *
   * @type {number}
   * @memberof CancelExperimentRunResponse
   */
  quoteGroupsCancelled: number;
}

/**
 * Check if a given object implements the CancelExperimentRunResponse interface.
 */
export function instanceOfCancelExperimentRunResponse(
  value: object,
): value is CancelExperimentRunResponse {
  if (
    !("quoteGroupsCancelled" in value) ||
    value["quoteGroupsCancelled"] === undefined
  )
    return false;
  return true;
}

export function CancelExperimentRunResponseFromJSON(
  json: any,
): CancelExperimentRunResponse {
  return CancelExperimentRunResponseFromJSONTyped(json, false);
}

export function CancelExperimentRunResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelExperimentRunResponse {
  if (json == null) {
    return json;
  }
  return {
    quoteGroupsCancelled: json["quoteGroupsCancelled"],
  };
}

export function CancelExperimentRunResponseToJSON(
  json: any,
): CancelExperimentRunResponse {
  return CancelExperimentRunResponseToJSONTyped(json, false);
}

export function CancelExperimentRunResponseToJSONTyped(
  value?: CancelExperimentRunResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quoteGroupsCancelled: value["quoteGroupsCancelled"],
  };
}
